'use es6';

import { createSelector } from 'reselect';

const presentationsSlidesSelector = presentation => presentation.slides;

export default createSelector(presentationsSlidesSelector, slides => slides.map(({
  largeUrl
}) => largeUrl));